import { createAction } from 'redux-actions';

import { 
    createType, 
    createAsyncTypes, 
    createAsyncActions 
} from '../../../commons/util/reduxAsync';

export const types = {
    MODAL_EDIT_USER: createType('perfilUsuario', 'MODAL_EDIT_USER'),
    USER_EDIT: createType('perfilUsuario', 'USER_EDIT'),
    LOADING: createType('perfilUsuario', 'LOADING'),
    SEARCH_USERS: createAsyncTypes('perfilUsuario', 'SEARCH_USERS'),
    EDIT_PROFILE_USER: createAsyncTypes('perfilUsuario', 'EDIT_PROFILE_USER'),
    SHOW_MSG_SUCCESS_EDIT: createType('perfilUsuario', 'SHOW_MSG_SUCCESS_EDIT')
};

export const actions = {
    modalEditUser: createAction(types.MODAL_EDIT_USER),
    userEdit: createAction(types.USER_EDIT), 
    searchUsers: createAsyncActions(types.SEARCH_USERS),
    handleLoading: createAction(types.LOADING),
    editProfileUser: createAsyncActions(types.EDIT_PROFILE_USER),
    showMsgSuccessEdit: createAction(types.SHOW_MSG_SUCCESS_EDIT)
};